import { Box, Typography, Radio, RadioGroup, FormControlLabel, FormControl } from '@mui/material';
import React, { FC, useState, ChangeEvent, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

type ProductionFinishedProps = {
    productionState: string;
    onChangeProduction: (value: string) => void;
    isOrderInvoiced?: boolean;
};

const ProductionFinished: FC<ProductionFinishedProps> = ({
    onChangeProduction,
    productionState,
    isOrderInvoiced,
}: ProductionFinishedProps) => {
    const { t: translate } = useTranslation(['orders']);
    const [production, setProduction] = useState('');

    useEffect(() => {
        setProduction(productionState);
    }, [productionState]);

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        setProduction((event.target as HTMLInputElement).value);
        onChangeProduction((event.target as HTMLInputElement).value);
    };

    return (
        <Box>
            <Typography variant="h4">{translate('orders:PRODUCTION_FINISHED')}</Typography>
            <FormControl component="fieldset">
                <RadioGroup row onChange={handleChange} value={production}>
                    <FormControlLabel
                        value="FINISHED"
                        control={
                            <Radio
                                color="secondary"
                                required
                                disabled={isOrderInvoiced}
                                data-test="production-finished.finished-radio"
                            />
                        }
                        label={translate('orders:FINISHED')}
                    />
                    <FormControlLabel
                        value="NOT_FINISHED"
                        control={
                            <Radio
                                color="secondary"
                                required
                                disabled={isOrderInvoiced}
                                data-test="production-finished.not-finished-radio"
                            />
                        }
                        label={translate('orders:NOT_FINISHED')}
                    />
                </RadioGroup>
            </FormControl>
        </Box>
    );
};

export default ProductionFinished;
